const cmsPurchasesEndpoints = {
  base: "/v1/cms/purchases",
  list: ({ page = 1, limit = 20, search = "", environment = "all" } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page || 1));
    params.set("limit", String(limit || 20));
    params.set("environment", String(environment || "all").toLowerCase());
    if (String(search || "").trim()) {
      params.set("search", String(search).trim());
    }
    return `/v1/cms/purchases?${params.toString()}`;
  },
  byId: (id) => `/v1/cms/purchases/${encodeURIComponent(String(id || ""))}`,
};

export default cmsPurchasesEndpoints;
